// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__RywM0","card":"Cards_card__2RZFo","infected":"Cards_infected__2shjI","recovered":"Cards_recovered__-2MO_","deaths":"Cards_deaths__3Ruq1"};